export const purifyLink = (link, persistParamKeys = []) => {
  const url = new URL(link);
  const keys = Array.from(url.searchParams.keys()).filter((it) => !persistParamKeys.includes(it));

  keys.forEach((key) => url.searchParams.delete(key));

  return url.toString();
};